import {AxiosInstance} from "axios";
import API from "../../utils/api";
import {Job, JobStatus} from "../../models/queue/job";
import {PaginatedResult} from "../../models/core/paginated.result";
import {PaginatedRequest} from "../../models/core/paginated.request";

export class QueueService {
    private api: AxiosInstance = API;

    getStatus(request: PaginatedRequest): Promise<PaginatedResult<Job>> {
        return this.api
            .get("queue", {
                params: request.toParams(),

            })
            .then((x) => x.data);
    }

    getJobStatus(id: number): Promise<{status: JobStatus, error: string}> {
        return this.api.get("queue/job/" + id + "/status").then(x => x.data);

    }

    cancel(id: number): Promise<void> {
        return this.api.post("queue/job/" + id + "/cancel");
    }

    replay(id: number): Promise<void> {
        return this.api.post("queue/job/" + id + "/replay");
    }
}
export const queueService = new QueueService();
